import { SxProps, Theme } from '@mui/material';
import {
    SegmentFilter,
    SegmentFilterEventCondition,
    SegmentFilterEventFields,
    SegmentFilterState,
    isMultiInputOperator as isMultiInputOperatorType,
} from 'domains/segments/types';
import Select from 'domains/core/components/Select';
import { getOperatorValues } from 'domains/segments/pages/SegmentCreatePage/Filter/utils';

type Props = {
    condition: SegmentFilterEventCondition;
    conditionIndex: number;
    filterIndex: number;
    filterOptions: SegmentFilter[];
    filterState: SegmentFilterState<SegmentFilterEventFields>;
    sx?: SxProps<Theme>;
    updateSegmentFilter: (
        index: number,
        filter: SegmentFilterState<SegmentFilterEventFields>,
        resetPreview?: boolean
    ) => void;
};

const OperatorInput = ({
    condition,
    conditionIndex,
    filterIndex,
    filterOptions,
    filterState,
    sx,
    updateSegmentFilter,
}: Props) => {
    const { categorySpecificFields } = filterState;
    const { conditions } = categorySpecificFields;

    const selectedFilterOption = filterOptions.find((filterOption) => filterOption.name === condition.name);

    const filterOperatorsValues = getOperatorValues(selectedFilterOption?.sqlType);

    const handleChangeOperator = (e: any) => {
        const newConditions = conditions.map((condition, index) => {
            if (index === conditionIndex) {
                const isMultiInputOperator = isMultiInputOperatorType(e.target.value);

                condition = {
                    ...(isMultiInputOperator && { autocompleteValue: [] }),
                    autocompleteInputValue: '',
                    name: condition.name,
                    operator: e.target.value,
                    value: isMultiInputOperator ? [] : '',
                };
            }
            return condition;
        });

        updateSegmentFilter(filterIndex, {
            ...filterState,
            categorySpecificFields: {
                ...categorySpecificFields,
                conditions: newConditions,
            },
        });
    };

    return (
        <Select
            label="Operator"
            value={condition.operator ?? ''}
            values={filterOperatorsValues}
            sx={{ textTransform: 'capitalize', width: '12rem', ...sx }}
            onChange={handleChangeOperator}
        />
    );
};

export default OperatorInput;
